"use client";
import { useProps } from "../../core/MantineProvider/use-props/use-props.mjs";
import { useStyles } from "../../core/styles-api/use-styles/use-styles.mjs";
import { polymorphicFactory } from "../../core/factory/polymorphic-factory.mjs";
import { Box } from "../../core/Box/Box.mjs";
import UnstyledButton_module_default from "./UnstyledButton.module.mjs";
import { jsx } from "react/jsx-runtime";
//#region packages/@mantine/core/src/components/UnstyledButton/UnstyledButton.tsx
const defaultProps = { __staticSelector: "UnstyledButton" };
const UnstyledButton = polymorphicFactory((_props) => {
	const props = useProps("UnstyledButton", defaultProps, _props);
	const { className, component = "button", __staticSelector, unstyled, classNames, styles, style, attributes, ...others } = props;
	return /* @__PURE__ */ jsx(Box, {
		...useStyles({
			name: __staticSelector,
			props,
			classes: UnstyledButton_module_default,
			className,
			style,
			classNames,
			styles,
			unstyled,
			attributes
		})("root", { focusable: true }),
		component,
		type: component === "button" ? "button" : void 0,
		...others
	});
});
UnstyledButton.classes = UnstyledButton_module_default;
UnstyledButton.displayName = "@mantine/core/UnstyledButton";
//#endregion
export { UnstyledButton };

//# sourceMappingURL=UnstyledButton.mjs.map